<template>
	<div>
		<CModal
			:show.sync="isShow"
			:close-on-backdrop="false"
			centered
		>
			<template #header-wrapper>
				<ModalHeaderWrapper :title="title" @onClose="close" />
			</template>
			<template #default>
				<BaseLoading v-if="paymentFailed.isLoading" />
				<div v-else>
					<template v-if="orderPaymentFailedHistories.length">
						<PaymentFailedHistory
							v-for="(orderPaymentFailedHistory, index) in orderPaymentFailedHistories"
							:key="index"
							:data="orderPaymentFailedHistory"
							:order-detail="orderDetail"
						/>
					</template>
					<template v-else>
						<p class="empty-text">There are no payment failed history for this order</p>
					</template>
				</div>
			</template>
			<template #footer>
				<BaseModalFooter
					:is-show-confirm="false"
					@onCancel="close"
				/>
			</template>
		</CModal>
	</div>
</template>


<script>
import ModalHeaderWrapper from '@/components/ModalHeaderWrapper.vue';
import BaseModalFooter from '@/components/BaseModalFooter.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import PaymentFailedHistory from '@/components/PaymentFailedHistory.vue';

export default {
	name: 'ModalPaymentFailedHistory',
	components: {
		PaymentFailedHistory,
		ModalHeaderWrapper,
		BaseModalFooter,
	},
	props: {
		orderId: {
			type: Number,
			required: true,
		},
		title: {
			type: String,
			default: 'Modal Payment Failed History',
		},
	},
	data() {
		return {
			isShow: false,
		};
	},
	computed: {
		...mapState('orders', {
			paymentFailed: 'paymentFailed',
			detail: 'detail',
		}),
		...mapGetters({
			orderDetail: 'orders/orderDetail',
		}),

		orderPaymentFailedHistories() {
			return this.paymentFailed.data;
		},
	},
	methods: {
		...mapActions({
			getOrderPaymentFailedHistory: 'orders/getOrderPaymentFailedHistory',
		}),
		async open() {
			this.isShow = true;

			// when open modal fetch order payment failed history
			await this.getOrderPaymentFailedHistory(this.orderId);
		},
		close() {
			this.isShow = false;
		},
	},
};
</script>

<style scoped lang="scss">
.empty-text {
	text-align: center;
	color: $color-gray-500;
	padding: 45px 0;
	margin: 0;
}
</style>
